export const types = {
    dark: 'dark',
    light: 'light',
};
export const spacings = {
    extraLarge: 'extraLarge',
    large: 'large',
    medium: 'medium',
    none: 'none',
    small: 'small',
};
